/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { XHRHttpRequest } from './core/XHRHttpRequest';

import { ArticleService } from './services/ArticleService';
import { AssistPhoneNumberService } from './services/AssistPhoneNumberService';
import { AuthService } from './services/AuthService';
import { BloodResultsService } from './services/BloodResultsService';
import { CloudFileService } from './services/CloudFileService';
import { DoctorNoteService } from './services/DoctorNoteService';
import { EventsService } from './services/EventsService';
import { GameService } from './services/GameService';
import { HealthDataService } from './services/HealthDataService';
import { InstitutionService } from './services/InstitutionService';
import { IntegrationService } from './services/IntegrationService';
import { MedStaffService } from './services/MedStaffService';
import { NotificationService } from './services/NotificationService';
import { OneTimeAuthService } from './services/OneTimeAuthService';
import { OtherService } from './services/OtherService';
import { PaymentService } from './services/PaymentService';
import { PdfService } from './services/PdfService';
import { ProgramService } from './services/ProgramService';
import { ProjectSettingService } from './services/ProjectSettingService';
import { PublicKeyService } from './services/PublicKeyService';
import { QuestionerService } from './services/QuestionerService';
import { QuestionerAnswerService } from './services/QuestionerAnswerService';
import { ScheduledNotificationsService } from './services/ScheduledNotificationsService';
import { ScreenService } from './services/ScreenService';
import { SmsService } from './services/SmsService';
import { SubscriberService } from './services/SubscriberService';
import { TestEmailService } from './services/TestEmailService';
import { TrackingService } from './services/TrackingService';
import { TranslationsService } from './services/TranslationsService';
import { UserService } from './services/UserService';
import { UserAdminService } from './services/UserAdminService';
import { WebhookService } from './services/WebhookService';
import { WebTestsService } from './services/WebTestsService';
import { WellKnownService } from './services/WellKnownService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class GerasApi {

    public readonly article: ArticleService;
    public readonly assistPhoneNumber: AssistPhoneNumberService;
    public readonly auth: AuthService;
    public readonly bloodResults: BloodResultsService;
    public readonly cloudFile: CloudFileService;
    public readonly doctorNote: DoctorNoteService;
    public readonly events: EventsService;
    public readonly game: GameService;
    public readonly healthData: HealthDataService;
    public readonly institution: InstitutionService;
    public readonly integration: IntegrationService;
    public readonly medStaff: MedStaffService;
    public readonly notification: NotificationService;
    public readonly oneTimeAuth: OneTimeAuthService;
    public readonly other: OtherService;
    public readonly payment: PaymentService;
    public readonly pdf: PdfService;
    public readonly program: ProgramService;
    public readonly projectSetting: ProjectSettingService;
    public readonly publicKey: PublicKeyService;
    public readonly questioner: QuestionerService;
    public readonly questionerAnswer: QuestionerAnswerService;
    public readonly scheduledNotifications: ScheduledNotificationsService;
    public readonly screen: ScreenService;
    public readonly sms: SmsService;
    public readonly subscriber: SubscriberService;
    public readonly testEmail: TestEmailService;
    public readonly tracking: TrackingService;
    public readonly translations: TranslationsService;
    public readonly user: UserService;
    public readonly userAdmin: UserAdminService;
    public readonly webhook: WebhookService;
    public readonly webTests: WebTestsService;
    public readonly wellKnown: WellKnownService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = XHRHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '2.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.article = new ArticleService(this.request);
        this.assistPhoneNumber = new AssistPhoneNumberService(this.request);
        this.auth = new AuthService(this.request);
        this.bloodResults = new BloodResultsService(this.request);
        this.cloudFile = new CloudFileService(this.request);
        this.doctorNote = new DoctorNoteService(this.request);
        this.events = new EventsService(this.request);
        this.game = new GameService(this.request);
        this.healthData = new HealthDataService(this.request);
        this.institution = new InstitutionService(this.request);
        this.integration = new IntegrationService(this.request);
        this.medStaff = new MedStaffService(this.request);
        this.notification = new NotificationService(this.request);
        this.oneTimeAuth = new OneTimeAuthService(this.request);
        this.other = new OtherService(this.request);
        this.payment = new PaymentService(this.request);
        this.pdf = new PdfService(this.request);
        this.program = new ProgramService(this.request);
        this.projectSetting = new ProjectSettingService(this.request);
        this.publicKey = new PublicKeyService(this.request);
        this.questioner = new QuestionerService(this.request);
        this.questionerAnswer = new QuestionerAnswerService(this.request);
        this.scheduledNotifications = new ScheduledNotificationsService(this.request);
        this.screen = new ScreenService(this.request);
        this.sms = new SmsService(this.request);
        this.subscriber = new SubscriberService(this.request);
        this.testEmail = new TestEmailService(this.request);
        this.tracking = new TrackingService(this.request);
        this.translations = new TranslationsService(this.request);
        this.user = new UserService(this.request);
        this.userAdmin = new UserAdminService(this.request);
        this.webhook = new WebhookService(this.request);
        this.webTests = new WebTestsService(this.request);
        this.wellKnown = new WellKnownService(this.request);
    }
}

